import React, { useEffect, useState } from 'react';

import { Alert, Snackbar } from '@mui/material';

export interface CommonSuccessNotificationProps {
  isOpened: number | boolean;
  mainText: string;
}

export default function CommonSuccessNotification(props: CommonSuccessNotificationProps) {
  const { isOpened, mainText } = props;

  const [open, setOpen] = useState(false);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (Boolean(isOpened)) {
      setOpen(true);
    }
  }, [isOpened]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity="success">
        {mainText}
      </Alert>
    </Snackbar>
  );
}
